import "./App.css";
import { BrowserRouter } from "react-router-dom";
import { CookiesProvider } from "react-cookie";
import { AxiosInterceptor } from "config/axiosInstance";
import { Toaster } from "react-hot-toast";
import Routing from "routes";
import { useAdminAuth } from "context/context";
import React from "react";
import { disableReactDevTools, normalDecryptData } from "config/config";

function App() {
  // disable react dev tools in production mode
  if (process.env.NODE_ENV === "production") disableReactDevTools();
  const { setRoles } = useAdminAuth();
  
  React.useEffect(() => {
    const roles = localStorage.getItem(process.env.REACT_APP_AUTH);
    if (roles) {
      let rolesData = roles ? JSON.parse(normalDecryptData(roles)) : [];
      setRoles(rolesData || []);
    }
    // eslint-disable-next-line
  }, []);

  
  return (
    <>
      <BrowserRouter basename="/">
        <CookiesProvider>
          <AxiosInterceptor>
            <Routing />
            <Toaster position="top-right" />
          </AxiosInterceptor>
        </CookiesProvider>
      </BrowserRouter>
    </>
  );
}

export default App;
